import { useEffect } from "react";
import {getBaseUrl} from "../../api/axios";

const NavigateToBackOffice = () => {
  useEffect(() => {
    window.location.href = `${getBaseUrl()}backoffice`;
  }, []);
  return null;
};

export default NavigateToBackOffice;
